import * as React from 'react';

import {useBookingMachine} from '../../hooks/useBookingMachine';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';


export const SlotRequestAlreadyExistsError = () => {
  const {t} = useLabelTranslation();
  const {bookingActor} = useBookingMachine();

  const handleGoBack = () => {
    bookingActor.send({type: 'refetchAvailability.go'});
  };

  return (
    <EmptyState
      imageVariant="data"
      title={t('Resubmission_not_allowed', 'Re-submission not allowed')}
      description={t(
        'Since_youve_already_responded_once_earlier_you_can_only_retry_again_in_24_hours',
        'Since you’ve already responded once earlier, you can only retry again in 24 hours.',
      )}
    >
      <Button
        size="medium"
        type="tertiary"
        onClick={handleGoBack}
        iconLeftName="chevron-left"
      >
        {t('Go_Back', 'Go Back')}
      </Button>
    </EmptyState>
  );
};
